<app-header></app-header>

<!-- Action Loading Overlay -->
@if (isActionLoading()) {
	<div class="action-loading-overlay">
		<div class="spinner-border text-primary"></div>
		<p>{{ selectedIds().length > 1 ? 'Elaborazione firma multipla in corso...' : 'Elaborazione firma in corso...' }}</p>
	</div>
}

<div class="welcome-info-block">
	<p class="welcome-label mb-1">Benvenuto</p>
	<h1 class="welcome-name">{{ userName() }}</h1>
	<p class="welcome-email">{{ userEmail() }}</p>
</div>

<div class="d-flex justify-content-between align-items-center pe-3 mb-3">
	<div class="section-title">Pratiche da firmare</div>
	<button class="btn btn-sm btn-primary mt-3" [class.active]="isSelectionMode()" (click)="isSelectionMode() ? cancelSelection() : isSelectionMode.set(true)">
		{{ isSelectionMode() ? 'Annulla' : 'Seleziona' }}
	</button>
</div>

<div class="container mb-5 pb-5">
	@if (loading()) {
		<div class="d-flex justify-content-center p-5">
			<div class="spinner-border spinner-teal"></div>
		</div>
	}

	@if (!loading() && pratiche().length === 0) {
		<div class="empty-state">
			<img src="assets/images/notfound.png" alt="Nessun documento" class="empty-state-img" />
			<p class="empty-state-text">
				Al momento non sono presenti
				<br />
				documenti da firmare.
			</p>
		</div>
	}

	@if (!loading() && pratiche().length > 0) {
		@for (pratica of pratiche(); track pratica.id) {
			<div
				class="card-pratica mb-3"
				[class.card-pratica-selected]="selectedIds().includes(pratica.id)"
				(click)="isSelectionMode() ? toggleSelection(pratica.id, $event) : openPratica(pratica)"
				(contextmenu)="toggleSelection(pratica.id, $event); $event.preventDefault()">
				<div class="card-pratica-icon" [class.selected]="selectedIds().includes(pratica.id)" (click)="toggleSelection(pratica.id, $event)">
					<i class="bi" [class.bi-file-earmark-fill]="selectedIds().includes(pratica.id)" [class.bi-file-earmark-text]="!selectedIds().includes(pratica.id)"></i>
					@if (selectedIds().includes(pratica.id)) {
						<div class="selection-badge">
							<i class="bi bi-check"></i>
						</div>
					}
				</div>

				<div class="card-pratica-body ms-2">
					<div class="card-pratica-name" title="{{ pratica.pratica }}">{{ pratica.pratica }}</div>
					<div class="card-pratica-company">{{ pratica.cliente }}</div>
					<div class="card-pratica-email">{{ pratica.utenteSegreteria }}</div>
					@if (pratica.note) {
						<div class="card-pratica-note">{{ pratica.note }}</div>
					} @else {
						<div class="card-pratica-note-empty">Nessuna nota aggiunta</div>
					}
					<div class="card-pratica-data-badge">
						{{ pratica.dataCreazionePratica | date : 'dd/MM/yyyy - HH:mm:ss' }}
					</div>
				</div>

				<div class="card-pratica-action">
					@if (isSelectionMode()) {
						<div class="selection-checkbox-mobile" (click)="toggleSelection(pratica.id, $event)">
							<i class="bi" [class.bi-check-circle-fill]="selectedIds().includes(pratica.id)" [class.bi-circle]="!selectedIds().includes(pratica.id)"></i>
						</div>
					} @else {
						<div class="icon-pen-action"></div>
					}
				</div>
			</div>
		}
	}
</div>

<!-- Floating Selection Bar -->
@if (selectedIds().length > 0) {
	<div class="floating-selection-bar-mobile">
		<div class="selection-info">
			<span class="count">{{ selectedIds().length }}</span>
			<span class="label">{{ selectedIds().length === 1 ? 'Pratica selezionata' : 'Pratiche selezionate' }}</span>
		</div>
		<div class="selection-actions">
			<button class="btn btn-outline-kf-mobile me-2" (click)="cancelSelection()">Annulla</button>
			<button class="btn btn-confirm-kf-mobile" (click)="signSelected()">Firma {{ selectedIds().length > 1 ? 'Tutte' : '' }}</button>
		</div>
	</div>
}
